SJ.LoadingScreen = {}

SJ.LoadingScreen.imagesToLoad = 0;
SJ.LoadingScreen.remainingToLoad = 0;

SJ.LoadingScreen.afterLoadingDone = false;

SJ.LoadingScreen.isVisible = false;

SJ.LoadingScreen.draw = () => {

  const {loadingImage, getLoadedPercent} = SJ.LoadingScreen;

  fill(0);
  rect(0, 0, SJ.SCREEN_WIDTH, SJ.SCREEN_HEIGHT);

  if(loadingImage)
    image(loadingImage, 0, 0, SJ.SCREEN_WIDTH, SJ.SCREEN_HEIGHT);

  const loadingBarLength = 12;
  const x = SJ.SCREEN_MIDDLE_X - 50 * loadingBarLength;

  push();
    fill(0, 0, 0, 40);
    rect(0, SJ.SCREEN_HEIGHT - 200, SJ.SCREEN_WIDTH, 220);

    fill(255);
    textStyle(BOLD);
    textSize(60)
    text(SJ.LoadingScreen.locationName.toUpperCase(), x, SJ.SCREEN_HEIGHT - 120);

    textSize(35);
    text(`ŁADOWANIE ${getLoadedPercent()}%`, x, SJ.SCREEN_HEIGHT - 90);
    rect(x, SJ.SCREEN_HEIGHT - 80, getLoadedPercent() * loadingBarLength, 32);

  pop();
}

SJ.LoadingScreen.reset = () => {
  SJ.LoadingScreen.imagesToLoad = 0;
  SJ.LoadingScreen.remainingToLoad = 0;
  SJ.LoadingScreen.afterLoadingDone = false;

  SJ.LoadingScreen.isVisible = true;
}

SJ.LoadingScreen.setLoadingImage = (locationName) => {
  if (locationName === 'Pekin2030') locationName = 'Pekin 2030';
  SJ.LoadingScreen.locationName = locationName;
  SJ.LoadingScreen.loadingImage = SJ.loadingScreenImages[locationName];
}

SJ.LoadingScreen.getLoadedPercent = () => {
  const percent = SJ.LoadingScreen.remainingToLoad === 0 ? 0 : 100 - Math.floor(SJ.LoadingScreen.remainingToLoad*100 / SJ.LoadingScreen.imagesToLoad) - 1;

  if(percent > 0) return percent;
  else return 1;
}

SJ.LoadingScreen.toDoAfterLoading = () => {

  SJ.mouseMoveEnable = true;

  SJ.jumper.reset();
  SJ.weather.createLightnigns();
  SJ.weather.setDefaultPercformanceCorrect();

  if(SJ.settings.SFX){
    SJ.gameSoundsContainer.play();

    SJ.SFXSoundManager.unlockPlaying();
  }
  else{
    SJ.SFXSoundManager.lockPlaying();
  }

  SJ.main._restartGame();

  console.log(`%c -----LOADING SCREEN----- ${SJ.imagesLoaded}`, 'color:orange')
  console.log('after loading done');
  console.log(``)
  SJ.LoadingScreen.isVisible = false;

  SJ.LoadingScreen.afterLoadingDone = true;
}